import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '@mui/material';
import { IoClose } from 'react-icons/io5';
import CommunityPost from './CommunityPost';

const CommunityPostModal = ({
   is_me,
   open,
   onClose,
   postData,
   postIndex,
   windowWidth = window.innerWidth,
   getBrandColor,
   onEditCategory,
   openInEditMode = false,
   ...communityPostProps
}) => {
   const { t } = useTranslation();
   const [modalAnimating, setModalAnimating] = useState(false);

   useEffect(() => {
      if (open) {
         setModalAnimating(false);
         document.body.style.overflow = 'hidden';
         // Small delay to ensure modal is rendered before starting animation
         setTimeout(() => {
            setModalAnimating(true);
         }, 10);
      } else {
         document.body.style.overflow = 'unset';
      }
      
      return () => {
         document.body.style.overflow = 'unset';
      };
   }, [open]);

   const handleClose = () => {
      setModalAnimating(false);
      setTimeout(() => {
         onClose();
      }, 300); // Match the CSS animation duration
   };

   const handleBackdropClick = (event) => {
      if (event.target === event.currentTarget) {
         handleClose();
      }
   };

   const supportsDvh = CSS && CSS.supports && CSS.supports('height', '95dvh');

   if (!postData) return null;

   return (
      <>
         {open && (
            <Modal
               open={open}
               onClose={handleClose}
               aria-labelledby="community-post-modal-title"
               aria-describedby="community-post-modal-description"
               style={{ zIndex: 3000, outline: '0' }}
               sx={{zIndex: 3000}}
            >
               <div
                  style={{
                     position: 'fixed',
                     top: 0,
                     left: 0,
                     right: 0,
                     bottom: 0,
                     outline: '0',
                     backgroundColor: 'rgba(0, 0, 0, 0.6)',
                     display: 'flex',
                     alignItems: windowWidth < 900 ? 'flex-end' : 'center',
                     justifyContent: 'center',
                     zIndex: 3000,
                     padding: windowWidth < 900 ? '0px' : '20px',
                     opacity: modalAnimating ? 1 : 0,
                     transition: 'opacity 0.3s ease-in-out'
                  }}
                  onClick={handleBackdropClick}
               >
                  <div
                     style={{
                        maxWidth: windowWidth < 600 ? '100%' : '650px',
                        width: '100%',
                        height: 'auto',
                        maxHeight: windowWidth < 900 ? (supportsDvh? '95dvh' : '95vh')  : '90vh',
                        backgroundColor: '#fff',
                        borderRadius: windowWidth < 900 ? '20px 20px 0px 0px' : '16px',
                        position: 'relative',
                        boxShadow: windowWidth < 900 ? '0 -10px 40px rgba(0, 0, 0, 0.15)' : '0 20px 60px rgba(0, 0, 0, 0.15)',
                        overflow: 'hidden',
                        transform: modalAnimating 
                           ? 'translateY(0)' 
                           : windowWidth < 900 
                              ? 'translateY(100%)' 
                              : 'scale(0.8) translateY(50px)',
                        opacity: modalAnimating ? 1 : 0,
                        transition: 'all 0.3s ease-out',
                     }}
                     onClick={(e) => e.stopPropagation()}
                  >
                     {/* Close button - positioned at top right of post content, styled like other top right items */}
                     {/* <button
                        onClick={handleClose}
                        style={{
                           position: 'absolute',
                           top: windowWidth < 900 ? '12px' : '20px',
                           right: postData.pinned ? (windowWidth < 900 ? '60px' : '20px') : (windowWidth < 900 ? '12px' : '16px'),
                           zIndex: 5000,
                           background: 'transparent',
                           border: 'none',
                           borderRadius: '4px',
                           display: 'inline-flex',
                           alignItems: 'center',
                           justifyContent: 'center',
                           cursor: 'pointer',
                           padding: '4px',
                           transition: 'background 0.15s',
                        }}
                        onMouseEnter={(e) => {
                           e.currentTarget.style.backgroundColor = '#f0f0f0';
                        }}
                        onMouseLeave={(e) => {
                           e.currentTarget.style.backgroundColor = '';
                        }}
                        aria-label={t('dashboard.closeModal')}
                     >
                        <IoClose style={{ fontSize: '16px', color: '#666' }} />
                     </button> */}

                     {/* Content section */}
                     <div
                        style={{
                           maxHeight: windowWidth < 900 ? (supportsDvh? '95dvh' : '95vh')  : '90vh',
                           overflow: 'auto',
                           opacity: modalAnimating ? 1 : 0,
                           transform: modalAnimating ? 'translateY(0)' : 'translateY(20px)',
                           transition: 'all 0.4s ease-out',
                           transitionDelay: modalAnimating ? '0.1s' : '0s'
                        }}
                     >
                        <div style={{ padding: '0px 16px 16px 16px' }}>
                           <CommunityPost
                              onEditCategory={onEditCategory}
                              openInEditMode={openInEditMode}
                              key={postIndex}
                              post_index={postIndex}
                              username={postData.username}
                              display_name={postData.display_name}
                              user_icon={postData.user_icon}
                              time={postData.time}
                              subscription={postData.subscription}
                              text={postData.text}
                              photos={postData.photos}
                              content_type={postData.content_type}
                              content_file={postData.file}
                              video={postData.video}
                              threads={postData.threads}
                                tags_list={postData.tags_list}
                              post_tier={postData.tier}
                              n_threads={postData.n_threads}
                              n_comments={postData.n_comments}
                              post_id={postData.post_id}
                              post_like_count={postData.like_count}
                              post_user_value_count={postData.user_like_value}
                              current_tier={postData.current_tier}
                              onClose={handleClose}
                              link={postData.link}
                              pinnedPost={postData.pinned}
                              is_me={is_me}
                              event_time={postData.event_time}
                              scheduled_date={postData.scheduled_date}
                              community_post_title={postData.community_post_title}
                              windowWidth={windowWidth}
                              getBrandColor={getBrandColor}
                              hideLocation={true}
                              {...communityPostProps}
                           />
                        </div>
                     </div>
                  </div>
               </div>
            </Modal>
         )}
      </>
   );
};

export default CommunityPostModal;
